import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import MatrikkelSearchEvents from '../MatrikkelSearchEvents.js'
import CollapseIcon from '../../../images/collapse copy 5.png'
import ExpandIcon from '../../../images/expand copy 5.png'

class Bruksenhet extends Component {
    state = {
        isOpened: false
    }

    UNSAFE_componentWillMount = () => {
        if (this.props.antall == 1) this.setState({isOpened: true})
    }

    toggleBruksenhet = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    showBruksenhet = (event) => {
        event.stopPropagation()
        this.props.onEvent({
            type: MatrikkelSearchEvents.ShowObject,
            data: {
                type: MatrikkelSearchEvents.ShowBruksenhet,
                bruksenhet: this.props.bruksenhet
            }
        })
    }


    render() {
        const { t } = this.props        
        var bruksenhet = this.props.bruksenhet
        var bruksenhetstype = bruksenhet.bruksenhetstypeKode ? bruksenhet.bruksenhetstypeKode.substr(0, bruksenhet.bruksenhetstypeKode.indexOf(' ')) : "";

        var formattedEtasjenummer = `0${bruksenhet.etasjenummer}`.slice(-2)
        var formattedLopenummer = `0${bruksenhet.lopenummer}`.slice(-2);
        var bruksenhetsnummer = `H${formattedEtasjenummer}${formattedLopenummer}`;

        return (
            <li>
                <div className="section-header subsection" onClick={this.toggleBruksenhet}>
                    <span className={`icon sublevel ${this.props.isLast ? 'sublevel-end' : ''}`}></span>                    
                    <span className="title">{bruksenhetstype} - {bruksenhetsnummer} - {bruksenhet.bygningsnummer}</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={`section-content${this.state.isOpened ? '' : ' collapsed'}`}>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('bygningsnummer')}</div>
                            <div className="value">{bruksenhet.bygningsnummer}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('etasjeplan')}</div>
                            <div className="value">{bruksenhet.etasjeplanKode}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('etasjenummer')}</div>
                            <div className="value">{bruksenhet.etasjenummer}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('lopenummer')}</div>
                            <div className="value">{bruksenhet.lopenummer}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('bruksenhetstype')}</div>
                            <div className="value">{bruksenhet.bruksenhetstypeKode}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('antallrom')}</div>
                            <div className="value">{bruksenhet.antallRom}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('antallbad')}</div>
                            <div className="value">{bruksenhet.antallBad}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('antallwc')}</div>
                            <div className="value">{bruksenhet.antallWC}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('bruksareal')}</div>
                            <div className="value">{bruksenhet.bruksareal}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('kjokkentilgang')}</div>
                            <div className="value">{bruksenhet.kjokkentilgang}</div>
                        </div>
                    </div>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(Bruksenhet)